module["exports"] = [
  "###-########",
  "####-########",
  "###########"
];
